import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import { Chip, Grid } from '@mui/material';

import NavigationTabs from "./NavigationTabs";
import SwipeableViews from 'react-swipeable-views';
import ProjectPage from './ProjectPage/ProjectPage';
import VideoPage from './VideoPage/VideoPage';
import DownloadPage from './DownloadPage/DownloadPage';

import { UpdateTabsEvent } from './UpdateTabsEvent';
import { UpdateSwipeabilityEvent } from './UpdateSwipeabilityEvent';
import VideoPlayerDialog from './VideoPage/VideoPlayerDialog';
import { VideoData } from './VideoPage/VideoData';
import { OpenVideoDialogEvent } from './OpenVideoDialogEvent';

import "./NavigationPageStyles.css";

export interface INavigationPageProps {

}

const NavigationPage = (props: INavigationPageProps) => {

    const [tab, setTab] = useState<0|1|2>(0);
    const [swipeability, setSwipeability] = useState<boolean>();
    const [videoDialogData, setVideoDialogData] = useState<VideoData>();
    const headerVideoRef = useRef<any>();

    useEffect(() => {

        let swipeableDiv = document.getElementsByClassName("react-swipeable-view-container")[0];

        if(swipeableDiv.firstChild !== null) {
            (swipeableDiv.firstChild as HTMLDivElement).style.overflow = "hidden";
        }

        window.addEventListener("swipeabilityUpdate", (update: UpdateSwipeabilityEvent) => setSwipeability(!update.sceneHovering));
        window.addEventListener("closeVideoDialog", () => {
            setVideoDialogData(undefined);
        });
        window.addEventListener("openVideoDialog", (event: OpenVideoDialogEvent) => {handleOpenVideoDialogEvent(event.data)});

        return () => {
            window.removeEventListener("swipeabilityUpdate", () => {});
            window.removeEventListener("closeVideoDialog", () => {});
            window.removeEventListener("openVideoDialog", () => {});
        }
    }, [])
    
    const updateView = (target: 0|1|2) => {
        setTab(target);
    }
    const handleChangeIndex = (newIndex: number) => {
        setTab(newIndex as 0|1|2);

        let update = new UpdateTabsEvent();
        update.tabIndex = newIndex as 0|1|2;

        window.dispatchEvent(update);
    }

    const handleOpenVideoDialogEvent = (target: VideoData) => {
        setVideoDialogData(target);
    }

    return(
        <>
            <Grid className="navigation-page-container-grid" container direction="row">
                <Grid className="header-container-item">
                    <video ref={headerVideoRef} className="header-video" autoPlay playsInline muted src="header_video_short.mp4" height="100%" width="100%" onPause={() => headerVideoRef?.current?.play()} />
                    <div className="header-group-name-div">
                        <Chip className="header-group-name-chip" color="error" label="Error 404: Physics not found - PhysxHCI" />
                    </div>
                    <div className="header-project-description">
                        <Chip className="header-project-description-chip" color="error" label="Universität Bayreuth - Mujoco Bachelorprojekt" />
                    </div>
                </Grid>
                <Grid id="tabs-container" className="tabs-container-item">
                    <NavigationTabs initSelectedTab={tab} updateView={updateView} />
                </Grid>
                <Grid className="page-content-container-item">
                    <SwipeableViews index={tab} disabled={!swipeability} onChangeIndex={handleChangeIndex}>
                        <div style={{height: "fit-content", width: "100%"}}>
                            <ProjectPage />
                        </div>
                        <div style={{height: "fit-content", width: "100%"}}>
                            <VideoPage />
                        </div>
                        <div style={{height: "fit-content", width: "100%"}}>
                            <DownloadPage />
                        </div>
                    </SwipeableViews>
                </Grid>
            </Grid>
            <VideoPlayerDialog videoData={videoDialogData} />
        </>
    );
}

export default NavigationPage;